import { DetailM2MTableFieldWidget, DslRender, Widget } from '@kunlun/dependencies';
import Comp from './DetailBaseCustomTableWidget.vue';
export class DetailBaseCustomTableWidget extends DetailM2MTableFieldWidget {
  @Widget.Reactive()
  mountedFlag = false;

  @Widget.Reactive()
  get _instance() {
    return this.getSelf();
  }

  public initialize(props) {
    super.initialize(props);    
    this.setComponent(Comp);
    return this;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }
  // actionBar有元素的时候 应该显示
  @Widget.Method()
  protected renderActionBarVNodes() {
    const table =  this.getDsl()?.widgets?.find(item=>item.type==='TABLE')
    const rowAction = table?.widgets.find((w) => w.slot === 'actionBar');
    if (rowAction) {
      return rowAction.widgets.map((w) => DslRender.render(w));
    }
    return null;
  }


  public async mountedProcess() {
    this.mountedFlag = true;
  }
}
